import { ResolveObjectionsModel } from '../../api/Argentia/endpoints/objections/model/objections'
import { apiPostResolveObjections } from '../../api/Argentia/endpoints/objections/objections.api'
import {
  AtlasUserModel,
  FilterTaskRequest,
  TaskCommentModel,
  TaskModel,
  TaskModelWithObjections,
  TaskPatchModel,
  TaskPostModel,
  TaskTypeModel
} from '../../api/Argentia/endpoints/tasks/model/tasks'
import {
  apiFetchGlobalerisClientFromDomain,
  apiFetchUsersFromGlobalerisClient,
  apiGetAtlasUsers,
  apiGetFilteredTasksExpanded,
  apiGetMeUsers,
  apiGetObjectionsByTaskDomain,
  apiGetObjectionsFromTaskEntity,
  apiGetTaskById,
  apiGetTaskComment,
  apiGetTasks,
  apiGetTasksExpanded,
  apiGetTaskTypes,
  apiGetTaskWithObjectionsById,
  apiPatchTask,
  apiPostTask,
  apiPostTaskActions,
  apiPostTaskComment
} from '../../api/Argentia/endpoints/tasks/tasks.api'
import { EnumDominioTarea } from '../../api/oData/enums/enumDominioTarea'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import { ObjectionsModel, ObjectionTableModel } from '../invoicesPage/invoicesPage.Model'
import { GlobalerisClientModel } from './tasks.model'

export const fetchTaskById = async (
  taskId: number
): Promise<ServiceResponse<TaskModel | undefined>> => {
  return await apiGetTaskById(taskId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTaskWithObjectionsById = async (
  taskId: number,
  taskDomain: EnumDominioTarea
): Promise<ServiceResponse<TaskModelWithObjections | undefined>> => {
  return await apiGetTaskWithObjectionsById(taskId, taskDomain)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchObjectionsByTaskDomain = async (
  taskDomain: EnumDominioTarea
): Promise<ServiceResponse<ObjectionTableModel[] | undefined>> => {
  return await apiGetObjectionsByTaskDomain(taskDomain)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchObjectionsFromTaskEntity = async (
  entityId: number,
  taskDomain: EnumDominioTarea
): Promise<ServiceResponse<ObjectionsModel[] | undefined>> => {
  return await apiGetObjectionsFromTaskEntity(entityId, taskDomain)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTasks = async (): Promise<ServiceResponse<TaskModel[] | undefined>> => {
  return await apiGetTasks()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTasksExpanded = async (): Promise<ServiceResponse<TaskModel[] | undefined>> => {
  return await apiGetTasksExpanded()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTasksFilteredExpanded = async (
  request: FilterTaskRequest
): Promise<ServiceResponse<TaskModel[] | undefined>> => {
  return await apiGetFilteredTasksExpanded(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createTask = async (
  request: TaskPostModel
): Promise<ServiceResponse<TaskModel | undefined>> => {
  return await apiPostTask(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateTask = async (
  taskId: number,
  request: TaskPatchModel
): Promise<ServiceResponse<TaskModel | undefined>> => {
  return await apiPatchTask(taskId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTaskTypes = async (): Promise<ServiceResponse<TaskTypeModel[] | undefined>> => {
  return await apiGetTaskTypes()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchTaskComments = async (
  taskId: number
): Promise<ServiceResponse<TaskCommentModel[] | undefined>> => {
  return await apiGetTaskComment(taskId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createTaskComment = async (
  taskId: number,
  request: TaskCommentModel
): Promise<ServiceResponse<TaskCommentModel | undefined>> => {
  return await apiPostTaskComment(taskId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchGlobalerisClientFromDomain = async (
  domain: string
): Promise<ServiceResponse<GlobalerisClientModel | undefined>> => {
  return await apiFetchGlobalerisClientFromDomain(domain)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchUsersFromGlobalerisClient = async (
  clientId: number
): Promise<ServiceResponse<string[] | undefined>> => {
  return await apiFetchUsersFromGlobalerisClient(clientId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchMeUsers = async (): Promise<ServiceResponse<string[] | undefined>> => {
  return await apiGetMeUsers()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchAtlasUsers = async (): Promise<ServiceResponse<AtlasUserModel[] | undefined>> => {
  return await apiGetAtlasUsers()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const executeTaskActions = async (
  taskId: number,
  request: any
): Promise<ServiceResponse<TaskCommentModel | undefined>> => {
  return await apiPostTaskActions(taskId, request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const resolveObjections = async (
  request: ResolveObjectionsModel
): Promise<ServiceResponse<any>> => {
  return await apiPostResolveObjections(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
